import React from "react";
import Modal from "@material-ui/core/Modal";
import { Button } from "@material-ui/core";
import "./Modal.css";

function CustomModal({ message, modalState, choiceState }) {
  const [showModal, setShowModal] = modalState;
  const [, setChoice] = choiceState;

  return (
    <>
      <Modal open={showModal} onClose={() => setShowModal(false)}>
        <div className="modal">
          <p>{message}</p>
          <div>
            <Button
              style={{ margin: "5px" }}
              variant="contained"
              color="primary"
              onClick={() => {
                setChoice(true);
                setShowModal(false);
              }}
            >
              Yes
            </Button>
            <Button
              style={{ margin: "5px" }}
              variant="contained"
              color="primary"
              onClick={() => {
                setChoice(false);
                setShowModal(false);
              }}
            >
              No
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default CustomModal;
